export default class InterfaceStorage {

    static COUNTRY = 'App\\Entity\\Geo\\Country';
    static CALCULATOR = 'App\\Entity\\Service\\Calculator';
    static AGGREGATION_CATEGORY = 'App\\Entity\\Aggregation\\Category';
    
    static components = {};

    static storageIdsCache = null;

    static getAll() {

        if (!InterfaceStorage.storageIdsCache) {

            InterfaceStorage.storageIdsCache = Object
                .getOwnPropertyNames(InterfaceStorage)
                .filter((name) => name === name.toUpperCase())
                .map((name) => InterfaceStorage[name]);
        }

        return InterfaceStorage.storageIdsCache;
    }

    static registerComponent(name, storage, component) {

        if (Array.isArray(storage))
            storage = InterfaceStorage.getStorageFromArray(storage);

        if (InterfaceStorage.components[storage] == undefined)
            InterfaceStorage.components[storage] = {};

        InterfaceStorage.components[storage][name] = component;
    }

    static getComponent(name, storage = 'memory') {

        if (Array.isArray(storage))
            storage = InterfaceStorage.getStorageFromArray(storage);

        return InterfaceStorage.components[storage]
            ? InterfaceStorage.components[storage][name]
            : null;
    }

    static getStorageFromArray(names) {

        return names.join(',');
    }
}